import { render, staticRenderFns } from "./TextGorunumCellRenderer.vue?vue&type=template&id=81b938e2&"
import script from "./TextGorunumCellRenderer.vue?vue&type=script&lang=js&"
export * from "./TextGorunumCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports